import { destinationPath } from "@travily/routes";
import type DestinationSearchHit from "@travily/types/pending/models/DestinationSearchHit";
import {
  isEstimatedCost,
  resolveDestinationPrice,
  resolveDestinationPriceNote,
} from "@/components/DestinationCard/resolve-destination";
import { MapPinCard } from "@/components/MapPinCard/MapPinCard";

export interface DestinationMapPinCardProps {
  hit: DestinationSearchHit;
  favorited?: boolean;
  onFavoriteToggle?: () => void;
  onClose: () => void;
  /** Full-bleed variant for the mobile map sheet (desktop popup stays 320px). */
  fullWidth?: boolean;
}

export function DestinationMapPinCard({
  hit,
  favorited,
  onFavoriteToggle,
  onClose,
  fullWidth,
}: DestinationMapPinCardProps) {
  // Lead the carousel with the curated cover image so the popup matches the card/detail page.
  // `photos` can be absent on a pin backed by an aggregation `_source` that never loaded as a card.
  const photos = hit.photos ?? [];
  const images = hit.cover_image
    ? [hit.cover_image, ...photos.filter((photo) => photo.src !== hit.cover_image?.src)]
    : photos;

  return (
    <MapPinCard
      description={hit.marketing_sentence}
      favorited={favorited}
      href={destinationPath(hit.country_slug, hit.slug)}
      image={images[0] ?? null}
      images={images.length > 1 ? images : undefined}
      imageSizes={fullWidth ? "100vw" : undefined}
      linkLabel={hit.name}
      onClose={onClose}
      onFavoriteToggle={onFavoriteToggle}
      price={resolveDestinationPrice(hit)}
      priceEstimated={isEstimatedCost(hit.cost_evidence_grade)}
      priceNote={resolveDestinationPriceNote(hit.cost_evidence_grade)}
      title={hit.name}
      widthClassName={fullWidth ? "w-full" : undefined}
    />
  );
}
